import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Chip } from 'primereact/chip';
import { AppConfig } from "../../../App.config";
import { Toast } from 'primereact/toast';
import GAS from '../../../GAS';

const ModalCompartilharPainel = ({ visible, setDialogCompartilhar, painel, setPainel, usuario }) => {
    const [colaborador, setColaborador] = useState('');
    const toast = useRef(null);

    const gasObj = GAS.getInstance();

    const domainValid = (email) => {
        let dominio = email.split("@")[1]

        if(
            AppConfig.DOMAINS_IFPB.includes(dominio) && 
            painel.colaboradores.includes(email) === false && 
            email !== usuario.email)
        {
            return true

        }
        else if (email === ''){
            toast.current.show({ severity: 'error', summary: 'ERRO!', detail: 'Deve ser informado o email do colaborador!', life: 8000, closable: false });
        
        }else if (painel.colaboradores.includes(email)){
            toast.current.show({ severity: 'error', summary: 'ERRO!', detail: 'O colaborador informado já existe no painel!', life: 8000, closable: false });
        
        }else if (email === usuario.email){
            toast.current.show({ severity: 'error', summary: 'ERRO!', detail: 'O proprietário do painel não pode ser adicionado como colaborador!', life: 8000, closable: false });
        
        }else if (!AppConfig.DOMAINS_IFPB.includes(dominio)){
            toast.current.show({ severity: 'error', summary: 'ERRO!', detail: 'O colaborador informado não possui um email institucional!', life: 8000, closable: false });
        }

        
        return false
    }

    const addColaborador = async () => {
        if (domainValid(colaborador)) {
            painel.colaboradores.push(colaborador);
            setPainel(painel);
            setColaborador('');

            if(await realizarRequisicao(painel.colaboradores)){
                toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: 'Colaborador adicionado com sucesso!', life: 5000, closable: false });
            }
            
        }
    };

    const removeColaborador = async (email) => {
        const novosColaboradores = painel.colaboradores.filter(c => c !== email);
        painel.colaboradores = novosColaboradores;
        setPainel(painel);

        if(await realizarRequisicao(painel.colaboradores)){
            toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: 'Colaborador removido com sucesso!', life: 5000, closable: false });
        }
    };


    const realizarRequisicao = async (listaColaboradores) => {
        try {
            const res = await gasObj.request(
                'MCPAPainelApropriador.instance.SERVICE.PATCHatualiozaColaborador',
                painel.proprietario,
                listaColaboradores
            )
            return true;

        } catch (error) {
            console.log("Não foi possível atualizar os colaboradores " + error)
        }
    }

    const footer = (
        <div>
            <div className="p-d-flex p-jc-center">
                <div className="p-inputgroup p-mb-8">
                    <span className="p-float-label">
                        <div className="p-d-flex" style={{width: '100%'}} >
                            <InputText value={colaborador} id="in" style={{ width: "10%" }} onChange={(e) => setColaborador(e.target.value)} />
                            <Button label="Adicionar" style={{ marginLeft: "5px" }} onClick={addColaborador} />
                            <label htmlFor="in" style={{ marginLeft: "10px" }}>Email</label>
                        </div>
                    </span>
                </div>
            </div>
            <div className="p-jc-center" style={{ marginTop: "10px", textAlign: "center" }}>
                {painel.colaboradores.map((colaborador) => (
                    <div key={colaborador}>
                        <Chip label={colaborador} icon="pi pi-user" style={{ marginLeft: "5px", marginTop: "5px" }} removable onRemove={() => removeColaborador(colaborador)} />
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <>
            <Dialog header="Compartilhar" footer={footer} visible={visible} style={{ width: '60vw' }} onHide={() => setDialogCompartilhar(false)} />
            <Toast ref={toast} />
        </>
        
    );
};

export default ModalCompartilharPainel;
